export default __webpack_public_path__ + "static/media/ChristmasTree.6dd2a88b.png";